const DIAGNOSTIC_EVENT_SCHEMA_VERSION = 1;
var DiagnosticEventType = /* @__PURE__ */ ((DiagnosticEventType2) => {
  DiagnosticEventType2["SESSION_STARTED"] = "SESSION_STARTED";
  DiagnosticEventType2["SESSION_COMPLETED"] = "SESSION_COMPLETED";
  DiagnosticEventType2["SESSION_PAUSED"] = "SESSION_PAUSED";
  DiagnosticEventType2["SESSION_RESUMED"] = "SESSION_RESUMED";
  DiagnosticEventType2["PROBLEMS_ADDED"] = "PROBLEMS_ADDED";
  DiagnosticEventType2["PROBLEM_STATUS_UPDATED"] = "PROBLEM_STATUS_UPDATED";
  DiagnosticEventType2["TEST_STARTED"] = "TEST_STARTED";
  DiagnosticEventType2["TEST_COMPLETED"] = "TEST_COMPLETED";
  DiagnosticEventType2["TEST_OUTCOME_PROPAGATED"] = "TEST_OUTCOME_PROPAGATED";
  DiagnosticEventType2["REPAIR_COMPLETED"] = "REPAIR_COMPLETED";
  DiagnosticEventType2["GUIDE_STARTED"] = "GUIDE_STARTED";
  DiagnosticEventType2["GUIDE_COMPLETED"] = "GUIDE_COMPLETED";
  DiagnosticEventType2["CONTENT_ACCESSED"] = "CONTENT_ACCESSED";
  DiagnosticEventType2["TESTS_REFRESHED"] = "TESTS_REFRESHED";
  DiagnosticEventType2["AI_CHAT_ENGAGED"] = "AI_CHAT_ENGAGED";
  DiagnosticEventType2["HELP_TICKET_SUBMITTED"] = "HELP_TICKET_SUBMITTED";
  DiagnosticEventType2["TICKET_CREATION_ATTEMPTED"] = "TICKET_CREATION_ATTEMPTED";
  DiagnosticEventType2["TICKET_CREATED"] = "TICKET_CREATED";
  DiagnosticEventType2["TICKET_CREATION_FAILED"] = "TICKET_CREATION_FAILED";
  DiagnosticEventType2["NOTES_UPDATED"] = "NOTES_UPDATED";
  DiagnosticEventType2["NOTE_IMAGE_UPLOADED"] = "NOTE_IMAGE_UPLOADED";
  DiagnosticEventType2["MANDATORY_NOTIFICATION_SHOWN"] = "MANDATORY_NOTIFICATION_SHOWN";
  DiagnosticEventType2["MANDATORY_NOTIFICATION_ACKNOWLEDGED"] = "MANDATORY_NOTIFICATION_ACKNOWLEDGED";
  DiagnosticEventType2["TEST_SELECTED"] = "TEST_SELECTED";
  DiagnosticEventType2["TEST_RANKING_OPENED"] = "TEST_RANKING_OPENED";
  DiagnosticEventType2["SLIDEOUT_OPENED"] = "SLIDEOUT_OPENED";
  DiagnosticEventType2["JOB_COMPLETED"] = "JOB_COMPLETED";
  DiagnosticEventType2["SUMMARY_REPORT_PRINTED"] = "SUMMARY_REPORT_PRINTED";
  DiagnosticEventType2["REPAIRS_VIEWED"] = "REPAIRS_VIEWED";
  DiagnosticEventType2["AI_CHAT_STARTED"] = "AI_CHAT_STARTED";
  DiagnosticEventType2["AI_CHAT_QUESTION_ASKED"] = "AI_CHAT_QUESTION_ASKED";
  DiagnosticEventType2["AI_CHAT_FEEDBACK_GIVEN"] = "AI_CHAT_FEEDBACK_GIVEN";
  DiagnosticEventType2["TRACERX_LAUNCH_REQUESTED"] = "TRACERX_LAUNCH_REQUESTED";
  DiagnosticEventType2["TRACERX_LAUNCHED"] = "TRACERX_LAUNCHED";
  return DiagnosticEventType2;
})(DiagnosticEventType || {});
const DIAGNOSTIC_SNAPSHOT_SCHEMA_VERSION = 4;
const DiagnosticSnapshotType = {
  TREELESS: "TREELESS",
  GUIDE: "GUIDE"
};
function applyDiagnosticEvent(snapshot, event) {
  var _a, _b, _c, _d;
  switch (event.eventType) {
    case DiagnosticEventType.SESSION_STARTED: {
      const { payload } = event;
      const diagnosticCodeStates = (payload.diagnosticCodes ?? []).map((dc) => ({
        problemId: dc.problemId,
        problemType: "DTC",
        code: dc.code,
        ecu: dc.ecu,
        name: dc.name,
        status: "unresolved",
        addedLater: false,
        addedOn: event.occurredOn,
        updatedOn: event.occurredOn,
        caseStartOn: event.occurredOn
      }));
      const symptomStates = (payload.symptoms ?? []).map((s) => ({
        problemId: s.problemId,
        problemType: "SYMPTOM",
        name: s.name,
        status: "unresolved",
        addedLater: false,
        addedOn: event.occurredOn,
        updatedOn: event.occurredOn,
        caseStartOn: event.occurredOn
      }));
      return {
        ...snapshot,
        sessionId: event.sessionId,
        projectId: event.projectId,
        schemaVersion: DIAGNOSTIC_SNAPSHOT_SCHEMA_VERSION,
        type: "TREELESS",
        user: payload.userId,
        status: "IN_PROGRESS",
        startedOn: event.occurredOn,
        lastActivityOn: event.occurredOn,
        sessionContext: {
          vehicleContext: {
            identifier: payload.vehicleIdentifier,
            platform: payload.vehicleAttributes ? { attributes: payload.vehicleAttributes } : void 0,
            diagnosticCodes: (payload.diagnosticCodes ?? []).map((dc) => ({
              ...dc,
              type: "DTC"
            })),
            symptoms: (payload.symptoms ?? []).map((s) => ({
              ...s,
              type: "SYMPTOM"
            })),
            telemetry: payload.telemetry
          },
          meta: {
            userId: payload.userId,
            actorId: payload.actorId,
            locale: payload.locale,
            timestamp: new Date(event.occurredOn).toISOString(),
            source: payload.source,
            sessionId: event.sessionId
          }
        },
        treelessDataInitial: payload.treelessDataInitial,
        treelessDataCurrent: payload.treelessDataInitial,
        sourcePayload: payload.sourcePayload,
        problemStates: [...diagnosticCodeStates, ...symptomStates],
        testStates: []
      };
    }
    case DiagnosticEventType.SESSION_COMPLETED: {
      return {
        ...snapshot,
        status: event.payload.status,
        completedOn: event.occurredOn,
        lastActivityOn: event.occurredOn
      };
    }
    case DiagnosticEventType.SESSION_PAUSED: {
      return {
        ...snapshot,
        status: "PAUSED",
        lastActivityOn: event.occurredOn
      };
    }
    case DiagnosticEventType.SESSION_RESUMED: {
      return {
        ...snapshot,
        status: "IN_PROGRESS",
        lastActivityOn: event.occurredOn
      };
    }
    case DiagnosticEventType.PROBLEMS_ADDED: {
      const { addedProblemIds, treelessDataCurrent } = event.payload;
      const existingIds = new Set(snapshot.problemStates.map((p) => p.problemId));
      const newStates = addedProblemIds.filter((id) => !existingIds.has(id)).map((id) => ({
        problemId: id,
        problemType: "DTC",
        status: "unresolved",
        addedLater: true,
        addedOn: event.occurredOn,
        updatedOn: event.occurredOn,
        caseStartOn: event.occurredOn
      }));
      return {
        ...snapshot,
        lastActivityOn: event.occurredOn,
        problemStates: [...snapshot.problemStates, ...newStates],
        ...treelessDataCurrent !== void 0 ? { treelessDataCurrent } : {}
      };
    }
    case DiagnosticEventType.PROBLEM_STATUS_UPDATED: {
      const { problemId, status, linkedTestRunIds } = event.payload;
      return {
        ...snapshot,
        lastActivityOn: event.occurredOn,
        problemStates: snapshot.problemStates.map((p) => {
          if (p.problemId !== problemId) return p;
          const isClosing = status === "resolved" || status === "ignored";
          return {
            ...p,
            status,
            updatedOn: event.occurredOn,
            ...isClosing && p.caseEndOn === void 0 ? { caseEndOn: event.occurredOn } : {},
            ...(linkedTestRunIds == null ? void 0 : linkedTestRunIds.length) ? {
              latestLinkedTestRunId: linkedTestRunIds[linkedTestRunIds.length - 1]
            } : {}
          };
        })
      };
    }
    case DiagnosticEventType.TEST_STARTED: {
      const { testId, testRunId, testName } = event.payload;
      const existing = snapshot.testStates.find((t) => t.testId === testId);
      if (existing) {
        return {
          ...snapshot,
          lastActivityOn: event.occurredOn,
          testStates: snapshot.testStates.map(
            (t) => t.testId === testId ? {
              ...t,
              latestRunId: testRunId,
              lastUpdatedOn: event.occurredOn
            } : t
          )
        };
      }
      return {
        ...snapshot,
        lastActivityOn: event.occurredOn,
        testStates: [
          ...snapshot.testStates,
          {
            testId,
            name: testName,
            firstStartedOn: event.occurredOn,
            lastUpdatedOn: event.occurredOn,
            latestRunId: testRunId,
            repairsPerformed: [],
            guideRuns: [],
            relatedContentAccesses: []
          }
        ]
      };
    }
    case DiagnosticEventType.TEST_COMPLETED: {
      const {
        testId,
        testRunId,
        testName,
        status,
        resultCode,
        source,
        completedOn,
        userInputs
      } = event.payload;
      const existing = snapshot.testStates.find((t) => t.testId === testId);
      let testStates = existing ? snapshot.testStates.map(
        (t) => t.testId === testId ? {
          ...t,
          status,
          lastCompletedOn: completedOn,
          lastUpdatedOn: event.occurredOn,
          latestRunId: testRunId,
          latestResultCode: resultCode,
          outcomeSource: source,
          userInputs
        } : t
      ) : [
        ...snapshot.testStates,
        {
          testId,
          name: testName,
          status,
          firstStartedOn: event.payload.startedOn,
          lastCompletedOn: completedOn,
          lastUpdatedOn: event.occurredOn,
          latestRunId: testRunId,
          latestResultCode: resultCode,
          outcomeSource: source,
          userInputs,
          repairsPerformed: [],
          guideRuns: [],
          relatedContentAccesses: []
        }
      ];
      const completedTest = testStates.find((t) => t.testId === testId);
      const sourcesToClean = (completedTest == null ? void 0 : completedTest.dependentTestIds) ?? [];
      if (sourcesToClean.length > 0) {
        testStates = testStates.map(
          (t) => sourcesToClean.includes(t.testId) ? {
            ...t,
            dependencyEffects: (t.dependencyEffects ?? []).filter(
              (e) => e.affectedTestId !== testId
            )
          } : t
        );
      }
      return { ...snapshot, lastActivityOn: event.occurredOn, testStates };
    }
    case DiagnosticEventType.TEST_OUTCOME_PROPAGATED: {
      const { affectedTestId, affectedTestName, sourceTestId, sourceTestRunId, effect } = event.payload;
      if (effect === "clear") {
        let testStates2 = snapshot.testStates.map((t) => {
          if (t.testId === affectedTestId) {
            const newDependentTestIds = (t.dependentTestIds ?? []).filter(
              (id) => id !== sourceTestId
            );
            return t.outcomeSource === "dependency" ? {
              ...t,
              status: void 0,
              outcomeSource: void 0,
              dependentTestIds: newDependentTestIds
            } : { ...t, dependentTestIds: newDependentTestIds };
          }
          return t;
        });
        testStates2 = testStates2.map(
          (t) => t.testId === sourceTestId ? {
            ...t,
            dependencyEffects: (t.dependencyEffects ?? []).filter(
              (e) => e.affectedTestId !== affectedTestId
            )
          } : t
        );
        return { ...snapshot, lastActivityOn: event.occurredOn, testStates: testStates2 };
      }
      const effectMap = {
        mark_failed: "failed",
        mark_passed: "passed",
        mark_unnecessary: "unnecessary"
      };
      const newStatus = effectMap[effect];
      if (!newStatus) return snapshot;
      const target = snapshot.testStates.find((t) => t.testId === affectedTestId);
      let testStates = target ? snapshot.testStates.map((t) => {
        if (t.testId !== affectedTestId) return t;
        const alreadyUserRun = t.outcomeSource !== void 0 && t.outcomeSource !== "dependency";
        return alreadyUserRun ? {
          ...t,
          dependentTestIds: [
            .../* @__PURE__ */ new Set([...t.dependentTestIds ?? [], sourceTestId])
          ]
        } : {
          ...t,
          status: newStatus,
          outcomeSource: "dependency",
          lastUpdatedOn: event.occurredOn,
          dependentTestIds: [
            .../* @__PURE__ */ new Set([...t.dependentTestIds ?? [], sourceTestId])
          ]
        };
      }) : [
        ...snapshot.testStates,
        {
          testId: affectedTestId,
          name: affectedTestName ?? affectedTestId,
          status: newStatus,
          outcomeSource: "dependency",
          firstStartedOn: event.occurredOn,
          lastUpdatedOn: event.occurredOn,
          dependentTestIds: [sourceTestId],
          repairsPerformed: [],
          guideRuns: [],
          relatedContentAccesses: []
        }
      ];
      testStates = testStates.map(
        (t) => t.testId === sourceTestId ? {
          ...t,
          dependencyEffects: [
            ...(t.dependencyEffects ?? []).filter(
              (e) => e.affectedTestId !== affectedTestId
            ),
            { affectedTestId, effect, fromTestRunId: sourceTestRunId }
          ]
        } : t
      );
      return { ...snapshot, lastActivityOn: event.occurredOn, testStates };
    }
    case DiagnosticEventType.REPAIR_COMPLETED: {
      const {
        repairCompletedId,
        repairId,
        repairName,
        fromTestId,
        fromTestRunId,
        notes
      } = event.payload;
      const target = snapshot.testStates.find((t) => t.testId === fromTestId);
      if (!target) return snapshot;
      if (target.repairsPerformed.some(
        (r) => r.repairCompletedId === repairCompletedId
      )) {
        return { ...snapshot, lastActivityOn: event.occurredOn };
      }
      return {
        ...snapshot,
        lastActivityOn: event.occurredOn,
        testStates: snapshot.testStates.map(
          (t) => t.testId === fromTestId ? {
            ...t,
            repairsPerformed: [
              ...t.repairsPerformed,
              {
                repairCompletedId,
                repairId,
                repairName,
                performedOn: event.occurredOn,
                fromTestId,
                fromTestRunId,
                notes
              }
            ]
          } : t
        )
      };
    }
    case DiagnosticEventType.GUIDE_STARTED: {
      const {
        guideRunId,
        guideId,
        guideName,
        fromTestId,
        fromTestRunId,
        linkedDiagnosticSessionId
      } = event.payload;
      if (!fromTestId) {
        return { ...snapshot, lastActivityOn: event.occurredOn };
      }
      const newGuideRun = {
        guideRunId,
        guideId,
        guideName,
        linkedDiagnosticSessionId,
        startedOn: event.occurredOn,
        status: "STARTED"
      };
      const target = snapshot.testStates.find((t) => t.testId === fromTestId);
      if (!target) {
        return {
          ...snapshot,
          lastActivityOn: event.occurredOn,
          testStates: [
            ...snapshot.testStates,
            {
              testId: fromTestId,
              name: fromTestId,
              firstStartedOn: event.occurredOn,
              lastUpdatedOn: event.occurredOn,
              repairsPerformed: [],
              guideRuns: [newGuideRun],
              relatedContentAccesses: []
            }
          ]
        };
      }
      if (target.guideRuns.some((g) => g.guideRunId === guideRunId)) {
        return { ...snapshot, lastActivityOn: event.occurredOn };
      }
      return {
        ...snapshot,
        lastActivityOn: event.occurredOn,
        testStates: snapshot.testStates.map(
          (t) => t.testId === fromTestId ? { ...t, guideRuns: [...t.guideRuns, newGuideRun] } : t
        )
      };
    }
    case DiagnosticEventType.GUIDE_COMPLETED: {
      const { guideRunId, status } = event.payload;
      const targetTest = snapshot.testStates.find(
        (t) => t.guideRuns.some((g) => g.guideRunId === guideRunId)
      );
      if (!targetTest) return snapshot;
      return {
        ...snapshot,
        lastActivityOn: event.occurredOn,
        testStates: snapshot.testStates.map(
          (t) => t.testId === targetTest.testId ? {
            ...t,
            guideRuns: t.guideRuns.map(
              (g) => g.guideRunId === guideRunId ? { ...g, status, endedOn: event.occurredOn } : g
            )
          } : t
        )
      };
    }
    case DiagnosticEventType.CONTENT_ACCESSED: {
      const {
        contentAccessId,
        contentId,
        attachmentId,
        fileName,
        contentType,
        action,
        fromTestId
      } = event.payload;
      if (!fromTestId) {
        return { ...snapshot, lastActivityOn: event.occurredOn };
      }
      const contentAccess = {
        contentAccessId,
        contentId,
        attachmentId,
        fileName,
        contentType,
        action,
        occurredOn: event.occurredOn
      };
      const target = snapshot.testStates.find((t) => t.testId === fromTestId);
      if (!target) {
        return {
          ...snapshot,
          lastActivityOn: event.occurredOn,
          testStates: [
            ...snapshot.testStates,
            {
              testId: fromTestId,
              name: fromTestId,
              firstStartedOn: event.occurredOn,
              lastUpdatedOn: event.occurredOn,
              repairsPerformed: [],
              guideRuns: [],
              relatedContentAccesses: [contentAccess]
            }
          ]
        };
      }
      if (target.relatedContentAccesses.some(
        (c) => c.contentAccessId === contentAccessId
      )) {
        return { ...snapshot, lastActivityOn: event.occurredOn };
      }
      return {
        ...snapshot,
        lastActivityOn: event.occurredOn,
        testStates: snapshot.testStates.map(
          (t) => t.testId === fromTestId ? {
            ...t,
            relatedContentAccesses: [
              ...t.relatedContentAccesses,
              contentAccess
            ]
          } : t
        )
      };
    }
    case DiagnosticEventType.MANDATORY_NOTIFICATION_SHOWN: {
      return {
        ...snapshot,
        lastActivityOn: event.occurredOn,
        mandatoryNotification: {
          ...snapshot.mandatoryNotification,
          shownOn: event.occurredOn,
          problemIds: event.payload.problemIds
        }
      };
    }
    case DiagnosticEventType.MANDATORY_NOTIFICATION_ACKNOWLEDGED: {
      return {
        ...snapshot,
        lastActivityOn: event.occurredOn,
        mandatoryNotification: {
          ...snapshot.mandatoryNotification ?? { problemIds: [] },
          acknowledgedOn: event.occurredOn
        }
      };
    }
    case DiagnosticEventType.NOTES_UPDATED: {
      return {
        ...snapshot,
        lastActivityOn: event.occurredOn,
        notes: {
          text: event.payload.text,
          updatedOn: event.occurredOn,
          images: ((_a = snapshot.notes) == null ? void 0 : _a.images) ?? []
        }
      };
    }
    case DiagnosticEventType.NOTE_IMAGE_UPLOADED: {
      const { fileId, originalName, mimeType } = event.payload;
      const existingImages = ((_b = snapshot.notes) == null ? void 0 : _b.images) ?? [];
      if (existingImages.some((img) => img.fileId === fileId)) {
        return { ...snapshot, lastActivityOn: event.occurredOn };
      }
      return {
        ...snapshot,
        lastActivityOn: event.occurredOn,
        notes: {
          text: ((_c = snapshot.notes) == null ? void 0 : _c.text) ?? "",
          updatedOn: ((_d = snapshot.notes) == null ? void 0 : _d.updatedOn) ?? event.occurredOn,
          images: [
            ...existingImages,
            { fileId, originalName, mimeType, uploadedOn: event.occurredOn }
          ]
        }
      };
    }
    case DiagnosticEventType.TESTS_REFRESHED:
    case DiagnosticEventType.AI_CHAT_ENGAGED:
    case DiagnosticEventType.TICKET_CREATION_ATTEMPTED:
    case DiagnosticEventType.TICKET_CREATED:
    case DiagnosticEventType.TICKET_CREATION_FAILED:
    case DiagnosticEventType.HELP_TICKET_SUBMITTED:
    case DiagnosticEventType.TRACERX_LAUNCH_REQUESTED:
    case DiagnosticEventType.TRACERX_LAUNCHED:
      return { ...snapshot, lastActivityOn: event.occurredOn };
    default:
      return snapshot;
  }
}
var TocEntityType = /* @__PURE__ */ ((TocEntityType2) => {
  TocEntityType2["CONTENT"] = "CONTENT";
  TocEntityType2["PROBLEM"] = "PROBLEM";
  TocEntityType2["CAUSE"] = "CAUSE";
  TocEntityType2["TEST"] = "TEST";
  TocEntityType2["REPAIR"] = "REPAIR";
  TocEntityType2["INPUT"] = "INPUT";
  TocEntityType2["PROJECT_ATTRIBUTES"] = "PROJECT_ATTRIBUTES";
  TocEntityType2["PRODUCT_LINE"] = "PRODUCT_LINE";
  TocEntityType2["ATTRIBUTE"] = "ATTRIBUTE";
  TocEntityType2["ATTRIBUTE_TAG"] = "ATTRIBUTE_TAG";
  TocEntityType2["PRODUCT"] = "PRODUCT";
  TocEntityType2["GUIDE"] = "GUIDE";
  TocEntityType2["GUIDE_NODE"] = "GUIDE_NODE";
  TocEntityType2["TEMPLATE"] = "TEMPLATE";
  TocEntityType2["DIRECTORY"] = "DIRECTORY";
  TocEntityType2["LANGUAGE_PACK"] = "LANGUAGE_PACK";
  TocEntityType2["SERIAL_NUMBER_MAPPING"] = "SERIAL_NUMBER_MAPPING";
  TocEntityType2["WARRANTY"] = "WARRANTY";
  TocEntityType2["FORM"] = "FORM";
  return TocEntityType2;
})(TocEntityType || {});
var TemplateKind = /* @__PURE__ */ ((TemplateKind2) => {
  TemplateKind2["MUTABLE"] = "MUTABLE";
  TemplateKind2["IMMUTABLE"] = "IMMUTABLE";
  return TemplateKind2;
})(TemplateKind || {});
var TocEntityStatus = /* @__PURE__ */ ((TocEntityStatus2) => {
  TocEntityStatus2["DRAFT"] = "DRAFT";
  TocEntityStatus2["STAGED"] = "STAGED";
  return TocEntityStatus2;
})(TocEntityStatus || {});
var InputType = /* @__PURE__ */ ((InputType2) => {
  InputType2["BOOLEAN"] = "BOOLEAN";
  InputType2["NUMBER"] = "NUMBER";
  InputType2["MAP"] = "MAP";
  return InputType2;
})(InputType || {});
var TestUserInputType = /* @__PURE__ */ ((TestUserInputType2) => {
  TestUserInputType2["BOOLEAN"] = "BOOLEAN";
  TestUserInputType2["NUMBER"] = "NUMBER";
  TestUserInputType2["Text"] = "TEXT";
  return TestUserInputType2;
})(TestUserInputType || {});
var TestUserInputTextOperator = /* @__PURE__ */ ((TestUserInputTextOperator2) => {
  TestUserInputTextOperator2["EQUALS"] = "=";
  TestUserInputTextOperator2["NOT_EQUALS"] = "!=";
  return TestUserInputTextOperator2;
})(TestUserInputTextOperator || {});
var TestUserInputRuleBooleanOperator = /* @__PURE__ */ ((TestUserInputRuleBooleanOperator2) => {
  TestUserInputRuleBooleanOperator2["EQUALS"] = "=";
  TestUserInputRuleBooleanOperator2["NOT_EQUALS"] = "!=";
  return TestUserInputRuleBooleanOperator2;
})(TestUserInputRuleBooleanOperator || {});
var TestUserInputRuleNumberOperator = /* @__PURE__ */ ((TestUserInputRuleNumberOperator2) => {
  TestUserInputRuleNumberOperator2["EQUALS"] = "=";
  TestUserInputRuleNumberOperator2["NOT_EQUALS"] = "!=";
  TestUserInputRuleNumberOperator2["GREATER_THAN"] = ">";
  TestUserInputRuleNumberOperator2["LESS_THAN"] = "<";
  TestUserInputRuleNumberOperator2["GREATER_THAN_OR_EQUAL"] = ">=";
  TestUserInputRuleNumberOperator2["LESS_THAN_OR_EQUAL"] = "<=";
  return TestUserInputRuleNumberOperator2;
})(TestUserInputRuleNumberOperator || {});
const TEST_OUTCOME = {
  PASS: "passed",
  FAIL: "failed"
};
const TEST_OUTCOME_ACTION = {
  MARK_UNNCESSARY: "mark_unnecessary",
  MARK_PASSED: "mark_passed",
  MARK_FAILED: "mark_failed",
  RECALIBRATE: "recalibrate"
};
const TEST_OUTCOME_ACTION_UI_CONFIG = {
  [TEST_OUTCOME_ACTION.MARK_UNNCESSARY]: {
    text: "Mark Unnecessary",
    className: ""
  }
};
const TEST_OUTCOME_UI_CONFIG = {
  [TEST_OUTCOME.PASS]: {
    text: "Pass",
    className: ""
  },
  [TEST_OUTCOME.FAIL]: {
    text: "Fail",
    className: ""
  }
};
var TestOutcome = /* @__PURE__ */ ((TestOutcome2) => {
  TestOutcome2["PASS"] = "PASS";
  TestOutcome2["FAIL"] = "FAIL";
  return TestOutcome2;
})(TestOutcome || {});
var CauseStatus = /* @__PURE__ */ ((CauseStatus2) => {
  CauseStatus2["CONFIRMED"] = "CONFIRMED";
  CauseStatus2["DISMISSED"] = "DISMISSED";
  return CauseStatus2;
})(CauseStatus || {});
var ContentType = /* @__PURE__ */ ((ContentType2) => {
  ContentType2["FILE"] = "FILE";
  ContentType2["LINK"] = "LINK";
  return ContentType2;
})(ContentType || {});
var ProblemType = /* @__PURE__ */ ((ProblemType2) => {
  ProblemType2["DTC"] = "DTC";
  ProblemType2["SYMPTOM"] = "SYMPTOM";
  return ProblemType2;
})(ProblemType || {});
var GuideNodeType = /* @__PURE__ */ ((GuideNodeType2) => {
  GuideNodeType2["NOTE"] = "NOTE";
  GuideNodeType2["WARNING"] = "WARNING";
  GuideNodeType2["CAUTION"] = "CAUTION";
  GuideNodeType2["QUESTION"] = "QUESTION";
  GuideNodeType2["SOLUTION"] = "SOLUTION";
  GuideNodeType2["USER"] = "USER";
  GuideNodeType2["FORM"] = "FORM";
  GuideNodeType2["FORM_SUBMISSION"] = "FORM_SUBMISSION";
  return GuideNodeType2;
})(GuideNodeType || {});
const DEFAULT_LOCALE = "en-US";
const DEFAULT_SN_LENGTH = 17;
var AttributeType = /* @__PURE__ */ ((AttributeType2) => {
  AttributeType2["TEXT"] = "TEXT";
  AttributeType2["NUMBER"] = "NUMBER";
  return AttributeType2;
})(AttributeType || {});
const NO_VALUE_ANSWER = "no_value";
function isGuideNodeSolution(entity) {
  return entity.type === "GUIDE_NODE" && entity.nodeType === "SOLUTION";
}
function isGuide(entity) {
  return entity.type === "GUIDE";
}
const DEFAULT_PRIORITY = 0.5;
var ChatAnswerFeedback = /* @__PURE__ */ ((ChatAnswerFeedback2) => {
  ChatAnswerFeedback2[ChatAnswerFeedback2["None"] = 0] = "None";
  ChatAnswerFeedback2[ChatAnswerFeedback2["Like"] = 1] = "Like";
  ChatAnswerFeedback2[ChatAnswerFeedback2["Dislike"] = -1] = "Dislike";
  return ChatAnswerFeedback2;
})(ChatAnswerFeedback || {});
const DEFAULT_SN_DISPLAY_NAME = "Serial Number";
const MAX_PRIORITY_LEVEL = 25;
const MIN_PRIORITY_LEVEL = 1;
const DEFAULT_PRIORITY_LEVEL = 13;
const MIN_COMPLEXITY_LEVEL = 1;
const MAX_COMPLEXITY_LEVEL = 5;
const DEFAULT_COMPLEXITY_LEVEL = 3;
const DEFAULT_TREELESS_DIAGNOSTICS_CONFIG = {
  dtcWeight: 0.5,
  symptomWeight: 0.5,
  tau: 0.5,
  k: 3
};
export {
  AttributeType,
  CauseStatus,
  ChatAnswerFeedback,
  ContentType,
  DEFAULT_COMPLEXITY_LEVEL,
  DEFAULT_LOCALE,
  DEFAULT_PRIORITY,
  DEFAULT_PRIORITY_LEVEL,
  DEFAULT_SN_DISPLAY_NAME,
  DEFAULT_SN_LENGTH,
  DEFAULT_TREELESS_DIAGNOSTICS_CONFIG,
  DIAGNOSTIC_EVENT_SCHEMA_VERSION,
  DIAGNOSTIC_SNAPSHOT_SCHEMA_VERSION,
  DiagnosticEventType,
  DiagnosticSnapshotType,
  GuideNodeType,
  InputType,
  MAX_COMPLEXITY_LEVEL,
  MAX_PRIORITY_LEVEL,
  MIN_COMPLEXITY_LEVEL,
  MIN_PRIORITY_LEVEL,
  NO_VALUE_ANSWER,
  ProblemType,
  TEST_OUTCOME,
  TEST_OUTCOME_ACTION,
  TEST_OUTCOME_ACTION_UI_CONFIG,
  TEST_OUTCOME_UI_CONFIG,
  TemplateKind,
  TestOutcome,
  TestUserInputRuleBooleanOperator,
  TestUserInputRuleNumberOperator,
  TestUserInputTextOperator,
  TestUserInputType,
  TocEntityStatus,
  TocEntityType,
  applyDiagnosticEvent,
  isGuide,
  isGuideNodeSolution
};
//# sourceMappingURL=types.esm.js.map
